var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-burger-button",class:{ 'tt-burger-button--active': _vm.active },on:{"click":_vm.buttonClicked}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }